import React, { useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useSelector } from "react-redux";
import { exoAppContextSelector } from "src/selectors";

import Modal from "@/messenger/components/Modal";
import { IDLE_TIMEOUT, PROMPT_TIMEOUT } from "@/messenger/constants/auth";
import { TExoAppContext } from "@/messenger/types/exoContext.types";
import appConfig from "@/messenger/config";

const UserActivityDetector = () => {

    const [showPrompt, setShowPrompt] = useState(false);

    const appContext: TExoAppContext = useSelector(exoAppContextSelector);
    
    const logOut = async () => {
        setShowPrompt(false);
        localStorage.removeItem('auth');
        (await appConfig.authConfig()).ifSome(auth => {
            const redirectUri = auth?.logout_redirect_uri || window.location.origin
            if (window.location.href.includes('textkit.statflo.com')) {
                window.location.replace(`https://sso.textkit.statflo.com/oauth2/logout/?client_id=${auth.client_id}&redirect_uri=${redirectUri}`)
            } else {
                window.location.replace(`https://ssoth.is/oauth2/logout/?client_id=${auth.client_id}&redirect_uri=${redirectUri}`)
            }
        }); 
    };
    
    const onIdle = () => {
        logOut();
    };
    
    const onActive = () => {
        setShowPrompt(false);
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        idleTimer.reset();
    };
    
    const onPrompt = () => {
        setShowPrompt(true);
    };
    
    // We can set the idleTimer based on the config we will receive in the customer config.
    // customer?.config?.idleTimeout will be the idleTimeout in milliseconds
    // customer?.config?.promptTimeout will be the promptTimeout in milliseconds
    const idleTimer = useIdleTimer({ onIdle, onPrompt, timeout: 100000000 || IDLE_TIMEOUT, promptTimeout: appContext?.promptTimeout || PROMPT_TIMEOUT, onActive });

    return (
        <Modal 
            type="idle"
            show={showPrompt}
            onClose={logOut}
            onOk={onActive}
        />
    );
};

export default UserActivityDetector;